// agent config
export const CREATE_AGENT_CONFIG = 'CREATE_AGENT_CONFIG';
export const FETCH_AGENT_CONFIG = 'FETCH_AGENT_CONFIG';
export const SET_GENERATED_PROMPT = 'SET_GENERATED_PROMPT';
export const SET_AGENT_LOADING = 'SET_AGENT_LOADING';
export const DELETE_AGENT_CONFIG = 'DELETE_AGENT_CONFIG';
export const TOGGLE_AGENT_STATUS = "TOGGLE_AGENT_STATUS";
export const SET_AGENT_ERROR = 'SET_AGENT_ERROR';
// webhook config
export const FETCH_WEBHOOK_CONFIG = 'FETCH_WEBHOOK_CONFIG';
export const CREATE_WEBHOOK_CONFIG = 'CREATE_WEBHOOK_CONFIG';
export const UPDATE_WEBHOOK_CONFIG = 'UPDATE_WEBHOOK_CONFIG';
export const SET_WEBHOOK_LOADING = 'SET_WEBHOOK_LOADING';
export const SET_WEBHOOK_ERROR = 'SET_WEBHOOK_ERROR';
export const DELETE_WEBHOOK_CONFIG = 'DELETE_WEBHOOK_CONFIG';
// chatbot config
export const FETCH_CHATBOT_CONFIG = 'FETCH_CHATBOT_CONFIG';
export const CREATE_CHATBOT_CONFIG = 'CREATE_CHATBOT_CONFIG';
export const UPDATE_CHATBOT_CONFIG = 'UPDATE_CHATBOT_CONFIG';
export const DELETE_CHATBOT_CONFIG = 'DELETE_CHATBOT_CONFIG';
export const SET_CHATBOT_LOADING = 'SET_CHATBOT_LOADING';
export const SET_CHATBOT_ERROR = 'SET_CHATBOT_ERROR';
// Podio lookup types
export const SET_PODIO_LOADING = 'SET_PODIO_LOADING';
export const SET_PODIO_ERROR = 'SET_PODIO_ERROR';

export const FETCH_PODIO_ACCOUNTS_SUCCESS = 'FETCH_PODIO_ACCOUNTS_SUCCESS';
export const FETCH_PODIO_ACCESS_TOKEN_SUCCESS = 'FETCH_PODIO_ACCESS_TOKEN_SUCCESS';
export const FETCH_PODIO_ORGS_SUCCESS = 'FETCH_PODIO_ORGS_SUCCESS';
export const FETCH_PODIO_SPACES_SUCCESS = 'FETCH_PODIO_SPACES_SUCCESS';
export const FETCH_PODIO_APPS_SUCCESS = 'FETCH_PODIO_APPS_SUCCESS';

export const SET_SELECTED_PODIO_ACCOUNT = 'SET_SELECTED_PODIO_ACCOUNT';
export const SET_SELECTED_PODIO_ORG = 'SET_SELECTED_PODIO_ORG';
export const SET_SELECTED_PODIO_SPACE = 'SET_SELECTED_PODIO_SPACE';
export const SET_SELECTED_PODIO_APP = 'SET_SELECTED_PODIO_APP';

export const CLEAR_PODIO_FROM_ORG = 'CLEAR_PODIO_FROM_ORG';     // clears org+space+app data
export const CLEAR_PODIO_FROM_SPACE = 'CLEAR_PODIO_FROM_SPACE'; // clears space+app data
export const CLEAR_PODIO_FROM_ACCOUNT = 'CLEAR_PODIO_FROM_ACCOUNT'; // clears everything after account


// --- Intents by domain ---
export const SET_INTENTS_LOADING   = 'SET_INTENTS_LOADING';
export const SET_INTENTS_ERROR     = 'SET_INTENTS_ERROR';
export const FETCH_INTENTS_SUCCESS = 'FETCH_INTENTS_SUCCESS';


// ai sense settings
export const FETCH_AI_SETTINGS = 'FETCH_AI_SETTINGS';
export const UPDATE_AI_SETTINGS = 'UPDATE_AI_SETTINGS';
export const SET_AI_SETTINGS_LOADING = 'SET_AI_SETTINGS_LOADING';
export const SET_AI_SETTINGS_ERROR = 'SET_AI_SETTINGS_ERROR';
